import React, { useState, useEffect } from "react";
import "./IndustrySolutions.css";
import water from "../images/scroll/water_in1.jpg"
import ChemicalsFertilizers from "../images/scroll/Chemicals&Fertilizer_in.jpg"
import FoodBeverage from "../images/scroll/Food&Beverage_in.webp"
import PulpPaper from "../images/scroll/Pulp&Paper_in.jpg"
import Power from "../images/scroll/power1.avif"
import Cement from "../images/scroll/Cement.jpg"

const images = [
  {
    src: water,
    title: "WATER",
  },
  {
    src: ChemicalsFertilizers,
    title: "Chemicals & Fertilizers",
  },
  {
    // src: "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
    src:FoodBeverage,
    title: "Food & Beverage",
  },
  {
    // src: "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
    src:PulpPaper,
    title: "Pulp & Paper",
  },
  {  src:Power,
    // src: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e",
    title: "Power",
  },
  { src:Cement,
    // src: "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
    title: "Cement",
  },
 
];

const IndustrySolutions = () => {


  const [activeIndex, setActiveIndex] = useState(0);

  // ✅ Auto change every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="accordion-gallery">
        {images.map((image, index) => (
          <div
            key={index}
            className={`panel ${activeIndex === index ? "active" : ""}`}
            style={{ backgroundImage: `url(${image.src})` }}
            onClick={() => setActiveIndex(index)}
          >
            <h3 className="panel-title">{image.title}</h3>
          </div>
        ))}
      </div>

    </div>

  );
};

export default IndustrySolutions;
